/*
  Dimension API request body/template
*/
import cloneDeep from 'lodash/cloneDeep';
import { DATASET } from '@utils/constants';

export const query = {
  type: 'group-by',
  dataset: DATASET,
  metrics: [], // append metric name selected in metrics panel
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  granularity: 'ALL',
  filter: [],
  limit: 200,
  groupBy: [
    '', // dimension name
  ],
  orderBy: 'desc',
  sortBy: [], // metric name
  options: {
    withTotals: true,
  },
};

const initialState = {
  dimensionName: '',
  query: null,
  response: null,
  isFetching: true,
  errorCode: 0,
  errorMsg: '',
  sort: 0,
  invalid: true,
};

export const createDimension = (dimensionName, sort) => ({
  ...cloneDeep(initialState),
  dimensionName,
  sort,
});
